/**
 * src/lib/voiceEvents.js — Voice pipeline event bus
 *
 * Simple event emitter for voice lifecycle events.
 * Uses window.dispatchEvent (CustomEvent) for cross-component communication.
 *
 * Supported events:
 *   voice:record_start        — recording started
 *   voice:record_stop         — recording stopped, audio captured
 *   voice:upload_start        — upload to server started
 *   voice:upload_complete     — upload to server finished
 *   voice:transcription_start — STT processing started
 *   voice:transcription_complete — transcript available
 *   voice:l0_start            — L0 interpreter started
 *   voice:l0_complete         — L0 interpreter finished
 *   voice:l1_start            — L1 CRM classifier started
 *   voice:l1_complete         — L1 CRM classifier finished
 *   voice:actions_created     — derived actions written to DB
 */

/**
 * Emit a voice lifecycle event
 * @param {string} eventName — one of the voice:* event names
 * @param {object} payload — event data (voiceRecordId, contextType, etc.)
 */
export function emitVoiceEvent(eventName, payload) {
  console.info('[VOICE EVENT]', eventName, payload);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
  }
}

/**
 * Subscribe to a voice lifecycle event
 * @param {string} eventName — one of the voice:* event names
 * @param {function} handler — callback receiving the CustomEvent
 * @returns {function} unsubscribe function
 */
export function onVoiceEvent(eventName, handler) {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(eventName, handler);
  return () => window.removeEventListener(eventName, handler);
}
